import { render } from "./ApprovedPaymentLiquidations.vue?vue&type=template&id=2723b62c"
import script from "./ApprovedPaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./ApprovedPaymentLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__